<template>
  <div id="sales-po">

    <v-text-field
      v-model="search"
      prepend-icon="search"
      label="Search"
      placeholder="Search by No.PO/Desc/Category"
      clearable
      single-line
      hide-details/>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="720px">
      <template v-slot:activator="{ on }">
        <v-btn
          color="general"
          class="mb-2"
          dark
          @click="newItem"
          v-on="on">New
        </v-btn>
      </template>
      <v-form
        id="form1-vue"
        ref="form1"
        v-model="valid1"
        :lazy-validation="lazyValidation1"
      >
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.poNo"
                    :rules="[rules.required]"
                    label="PO No"
                    class="blue-input"/>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.amount"
                    :rules="[rules.required, rules.number]"
                    label="Amount"
                    class="blue-input"/>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        :rules="[rules.required]"
                        label="PO Date *"
                        hint="DD/MM/YYYY"
                        required
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.poDate"
                      no-title
                      @input="menu = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-select
                    v-model="editedItem.category"
                    :items="categories"
                    :rules="[rules.required]"
                    :disabled="editedIndex > -1"
                    menu-props="auto"
                    label="Category *"
                    required
                    class="blue-input"
                    @change="categoryOnChange"
                  />
                </v-flex>
                <!--                <v-flex-->
                <!--                  xs12-->
                <!--                  sm6-->
                <!--                  md4-->
                <!--                >-->
                <!--                  <v-select-->
                <!--                    :items="companies"-->
                <!--                    v-model="editedItem.company"-->
                <!--                    :rules="[rules.required]"-->
                <!--                    menu-props="auto"-->
                <!--                    item-text="name"-->
                <!--                    item-value="id"-->
                <!--                    label="Company *"-->
                <!--                    placeholder="Select..."-->
                <!--                    return-object-->
                <!--                  />-->
                <!--                </v-flex>-->
                <v-flex
                    xs12
                    sm6
                    md4>
                  <v-text-field
                      v-show="showProjectAddInfo"
                      v-model="editedItem.project.addInfo"
                      label="Project Add. Info"
                      class="blue-input"/>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4>
                  <v-combobox
                    v-model="editedItem.company"
                    :items="companies"
                    :rules="[rules.required]"
                    :search-input.sync="searchCompany"
                    hide-no-data
                    placeholder="type 3 words to search..."
                    label="Company *"
                    item-text="name"
                    item-value="id"
                    return-object
                    required
                    @input="getQuos"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-textarea
                    v-model="editedItem.desc"
                    label="Description"
                    clearable
                    class="blue-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12>
                  <v-btn
                    color="general"
                    class="mb-2"
                    dark
                    @click="addUserSales"
                  ><v-icon>
                    person_add
                  </v-icon>
                  </v-btn>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12>
                  <v-data-table
                    :headers="headersSalesSelection"
                    :items="editedItem.salesUserPo"
                    :total-items="5"
                    :rows-per-page-items="[5]"
                    item-key="id"
                    no-data-text="Please Select Item"
                    dense
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td>
                          <v-icon
                            medium
                            @click.stop="deleteSalesUserPo(props.item)">delete
                          </v-icon>
                        </td>
                        <td><v-edit-dialog
                          :return-value="props.item.username"
                          lazy
                          large
                          @update:returnValue="onUpdateSalesUserPo(props.item, $event)"
                          @click.native.stop
                          @save="saveInline"
                          @cancel="cancelInline"
                          @close="closeInline"
                        ><div class="">{{ props.item.username }}
                          <v-icon small>mdi-pencil</v-icon>
                        </div>
                          <template v-slot:input>
                            <v-select
                              v-model="selectedSalesUserPo"
                              :items="userLogins"
                              :item-text="usernameItemText"
                              item-value="username"
                              return-object
                              menu-props="auto"
                            >
                              <template v-slot:label>
                                Select Username <v-icon style="vertical-align: middle">search</v-icon>
                              </template>
                            </v-select>
                          </template>
                        </v-edit-dialog>
                        </td>
                        <td> {{ props.item.firstName }}</td>
                        <td><v-edit-dialog
                          :return-value="props.item.pctg"
                          lazy
                          large
                          @update:returnValue="onUpdatePctg(props.item, $event)"
                          @click.native.stop
                          @save="saveInline"
                          @cancel="cancelInline"
                          @close="closeInline"
                        >
                          <div class="">{{ props.item.pctg }}
                            <v-icon small>mdi-pencil</v-icon>
                          </div>
                          <template v-slot:input>
                            <v-text-field
                              v-model.number="props.item.pctg"
                              :rules="[rules.percentage]"
                              type="number"
                              single-line
                              autofocus
                            />
                          </template>
                        </v-edit-dialog>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="quotations"
                    :item-text="(item) => {return item.refNo + ' - ' + item.name}"
                    v-model="editedItem.quotation"
                    menu-props="auto"
                    item-value="id"
                    label="Open Quotation"
                    placeholder="Select..."
                    return-object
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm8
                  md6>
                  <v-btn
                    :disabled="selectFileDisabled"
                    class="ma-auto"
                    dark
                    small
                    color="general"
                    @click="$refs.inputUpload.click()">
                    select file
                  </v-btn>
                  <input
                    v-show="false"
                    ref="inputUpload"
                    type="file"
                    accept="image/x-png,image/jpeg,application/pdf"
                    @change="loadFile">
                  <v-chip
                    v-show="showFilename"
                    class="ma-1"
                    color="general"
                    label
                    outline
                  >
                    <v-icon left>mdi-file-check</v-icon>
                    {{ attachment.name || true }}
                  </v-chip>
                  <!--                  <v-img-->
                  <!--                    v-show="showFilename"-->
                  <!--                    :src="fileUrl"-->
                  <!--                    contain-->
                  <!--                    aspect-ratio="1"/>-->
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="red darken-1"
              flat
              @click="close">Cancel
            </v-btn>
            <v-btn
              :disabled="!valid1"
              color="green darken-1"
              flat
              @click="saveFormData"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-btn
      color="general"
      dark
      class="mb-2 ml-1 mr-1"
      @click="$refs.downloadExcel.generate()"
    >
      <download-excel
        ref="downloadExcel"
        :fetch="fetchData"
        :fields="excelFields"
        :before-generate="showProgressBar"
        :before-finish="hideProgressBar"
        class="btn btn-default"
        worksheet="worksheet"
        name="PO-All.xls">
        <v-icon>mdi-file-excel</v-icon>&nbsp;
      </download-excel>Export All
    </v-btn>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="DataList"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsAmount"
      :total-items="totalRows"
      dense
      expand
      loading-text="Loading... Please wait"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-icon
              class="mr-2"
              medium
              @click.stop="editItem(props.item)">edit
            </v-icon>
            <v-icon
              medium
              @click.stop="dialogDeleteShow(props.item)">delete
            </v-icon>
          </td>
          <td>
            <a
              :style="isFileExists(props.item) ? 'color:green' : 'color:rgba(0,0,0,.87)'"
              href="#"
              @click.stop="openFile(props.item)">{{ props.item.poNo }}</a>
          </td>
          <td>{{ props.item.desc }}</td>
          <td>{{ props.item.company.name }}</td>
          <td>{{ props.item.poDate }}</td>
          <td class="price-format">{{ toPriceFormat(props.item.amount) }}</td>
          <td>{{ props.item.category }}</td>
          <td>{{ showProject(props.item) }}</td>
          <td>{{ showQuotation(props.item) }}</td>
          <td style="padding:0 5px 0 0">
            <v-btn
              v-show="showDownloadBOM(props.item)"
              color="green darken-1"
              text
              flat
              dark
              @click="downloadBomListXls(props.item)"
            >
              Download
            </v-btn>
          </td>
          <td> {{ showSalesUserPo(props.item.salesUserPo) }}</td>
          <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
          <td>{{ props.item.lastUpdateBy }}</td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog2"
      min-width="200px"
      max-width="960px">
      <!--              <template v-slot:activator="{ on }">-->
      <!--                <a-->
      <!--                    href="#"-->
      <!--                    v-on="on"-->
      <!--                    @click.stop="openImage(props.item)">{{ props.item.poNo }}</a>-->
      <!--              </template>-->
      <v-card>
        <img
          id="poImageContainer"
          :src="imageDownloadUrl"
          @error="imageFallback">
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="red darken-1"
            text
            flat
            @click="close"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDelete"
      max-width="400px">
      <v-card>
        <v-card-title class="headline">System Message Confirmation</v-card-title>
        <v-card-text>
          Are you sure want to remove this record? <br>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="red darken-1"
            text
            flat
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            flat
            @click="deleteItem(deleteItemRecord)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-icon
        size="16"
        @click="snack = false"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </div>
</template>
<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import axios from 'axios'

  export default {
    name: 'SalesPo',
    mixins: [displayFormatterMixins],
    data: () => ({
      categories: [
        'GOODS', 'SERVICE', 'PROJECT'
      ],
      selectFileDisabled: false,
      showFilename: false,
      file: {},
      fileUrl: '',
      imageBase64: '',
      filePath: '',
      fileName: '',
      imageDownloadUrl: require('@/assets/img/no-image-200px.png'),
      showImageError: false,
      menu: false,
      mixins: [displayFormatterMixins],
      snack: false,
      snackText: '',
      snackColor: '',
      dialog: false,
      valid1: false,
      lazyValidation1: false,
      dialog2: false,
      valid2: false,
      lazyValidation2: false,
      showProjectAddInfo: false,
      editedIndex: -1,
      selectedSalesUserPo: {},
      editedItem: {
        id: null,
        desc: '',
        poNo: '',
        poDate: '',
        amount: 0,
        category: '',
        company: {
          id: null,
          name: ''
        },
        project: {
          id: null,
          refNo: '',
          name: '',
          addInfo: '',
        },
        quotation: {
          id: '',
          refNo: '',
          name: ''
        },
        fileName: '',
        filePath: '',
        salesUserPo: []
      },
      defaultItem: {
        id: null,
        desc: '',
        poNo: '',
        poDate: '',
        amount: 0,
        category: '',
        company: {
          id: null,
          name: ''
        },
        project: {
          id: null,
          refNo: '',
          name: '',
          addInfo: '',
        },
        quotation: {
          id: null,
          refNo: '',
          name: ''
        },
        fileName: '',
        filePath: '',
        salesUserPo: []
      },
      attachment: {},
      rules: {
        required: value => !!value || 'Required',
        percentage: value => (value >= 0 && value <= 100) || 'Must lower than 101',
        number: value => !isNaN(value) || 'Must be numeric',
        time: value => {
          // ignore `:` masked already
          const pattern = /^([0-1]?[0-9]|2[0-4])([0-5][0-9])(:[0-5][0-9])?$/
          return !value || pattern.test(value) || 'Invalid 24h time format'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
      },
      companies: [],
      quotations: [],
      pagination: { sortBy: 'poDate', descending: true },
      DataList: [],
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      userLogins: [],
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'No PO', value: 'poNo' },
        { text: 'Desc', value: 'desc' },
        { text: 'Company', value: 'company.id' },
        { text: 'PO Date', value: 'poDate' },
        { text: 'Amount', value: 'amount', align: 'right' },
        { text: 'Category', value: 'category' },
        { text: 'Project Ref', value: 'project.refNo' },
        { text: 'Quoation Ref', value: 'quotation.refNo' },
        { text: 'BOM List', value: '', sortable: false },
        { text: 'Sales Users', value: 'salesUserPo', sortable: false },
        { text: 'Update Date Time', value: 'lastUpdateDate' },
        { text: 'Update By', value: 'lastUpdateBy' }
      ],
      headersSalesSelection: [
        { text: '', value: '', sortable: false },
        { text: 'Username', value: 'username', sortable: false },
        { text: 'Name', value: 'firstName', sortable: false },
        { text: 'Percentage', value: 'percentage', sortable: false }
      ],
      SubDataList: [],
      totalRowsSub: 0,
      paginationSub: { sortBy: 'username', descending: true },
      searchCompany: '',
      imgCounter: 1,
      excelFields: {
        'No PO': 'poNo',
        'Desc': 'desc',
        'Company': 'company.name',
        'PO Date': {
          callback: (value) => {
            return new Date(value.poDate).toLocaleDateString('en-GB')
          }
        },
        'Amount': 'amount',
        'Category': 'category',
        'Project Ref': 'project.refNo',
        'Quoation Ref': 'quotation.refNo',
        'Update By': 'lastUpdateBy',
        'Update Date Time': {
          callback: (value) => {
            return new Date(value.lastUpdateDate).toLocaleDateString('en-GB')
          }
        }
      }
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.editedItem.poDate)
      }

    },
    watch: {
      pagination: {
        async handler () {
          console.debug('pagination watcher')
          this.getSalesPo()
        }
      },
      search () {
        console.debug('search watcher')
        this.debouncedGetData()
      },
      searchCompany () {
        if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
      // 'editedItem.company': function (newVal, oldVal) {
      //   console.info('watcher editedcompany start')
      //   console.info(newVal)
      //   console.info(newVal)
      //   console.info('watcher editedcompany end')
      // }
    },
    created () {
      this.debouncedGetData = _.debounce(this.getSalesPo, 500)
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
      this.userLogins = this.getUserLogins()
    },
    methods: {
      async categoryOnChange () {
        if (this.editedItem.category === 'PROJECT') {
          this.showProjectAddInfo = true
        } else {
          this.showProjectAddInfo = false
        }
      },
      async fetchData () {
        const response = await this.$http.get(`/api/salespo/all`)
        return response.data
      },
      showProgressBar () {
        this.loadingBar = true
      },
      hideProgressBar () {
        this.loadingBar = false
      },
      async newItem () {
        this.getQuos()
        // this.getCompanies()
      },
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select`)
          this.userLogins = response.data
          console.debug(this.userLogins)
        } catch (error) {
          console.log(error)
        }
      },
      usernameItemText (item) {
        if (item.employee) { // bug workaround
          return item.username + ' (' + item.employee.firstName + ')'
        } else {
          return item.username
        }
      },
      addUserSales () {
        let obj = {
          id: '',
          username: '',
          firstName: '',
          pctg: 0
        }
        if (this.editedItem.salesUserPo && this.editedItem.salesUserPo.length <= 3) {
          this.editedItem.salesUserPo.push(obj)
        } else {
          this.cancelInline('Maximum Only 3')
        }
      },
      onUpdatePctg (item, value) {
        console.debug(value)
        console.debug(item)
        item.pctg = value > 100 || value < 0 ? '' : value
      },
      onUpdateSalesUserPo (item, value) {
        console.debug(value)
        console.debug(item)
        console.debug(this.selectedSalesUserPo)
        item.firstName = this.selectedSalesUserPo.employee.firstName
        item.id = this.selectedSalesUserPo.id
        item.username = this.selectedSalesUserPo.username
      },
      deleteSalesUserPo (rec) {
        this.editedItem.salesUserPo.splice(this.DataList.indexOf(rec), 1)
      },

      async downloadBomListXls (item) {
        try {
          let response = await axios({
            url: `/api/excel/bom-po/${item.id}`,
            method: 'GET',
            headers: {
              // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
              'Accept': '*/*'
            },
            responseType: 'blob' // important,
          })
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.quotation.name + '.xlsx') // or any other extension
          // document.body.appendChild(link)
          link.click()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      imageFallback () {
        if (this.showImageError) {
          this.imageDownloadUrl = ''
        } else {
          this.imageDownloadUrl = require('@/assets/img/no-image-200px.png')
          this.showImageError = true
        }
      },
      async loadFile (e) {
        // const files = e.target.files
        const fileref = this.$refs.inputUpload.files
        const validFile = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf']
        console.debug(fileref.length)
        // eslint-disable-next-line eqeqeq
        if (fileref[0] === undefined || !validFile.includes(fileref[0].type.toLowerCase()) ||
          fileref.length > 1024 * 1024 * 4) {
          this.fileFormatSnack()
          return
        }
        if (fileref[0] !== undefined) {
          console.debug(fileref[0].name)
          console.debug('Type: ' + fileref[0].type)
          console.debug('Size: ' + fileref[0].size + ' bytes')
          const fr = new FileReader()
          fr.readAsDataURL(fileref[0])
          fr.addEventListener('load', async () => {
            // console.debug(fr.result)
            // this.imageFile = files[0] // this is an image file that can be sent to server...
            // let response = await this.$store.dispatch('uploadFile', { file, endpoint })
            // console.debug(response)
            this.attachment = fileref[0]
            this.showFilename = true
            this.fileUrl = URL.createObjectURL(this.attachment)
          })
        } else {
          this.attachment = {}
        }
      },
      isFileExists (obj) {
        if (!_.isEmpty(obj.fileName) && !_.isEmpty(obj.filePath)) {
          return true
        }
        return false
      },
      showDownloadBOM (obj) {
        if (
        !_.isEmpty(obj.quotation) && !_.isEmpty(obj.quotation.id)) {
          return true
        }
        return false
      },
      showProject (obj) {
        if (!_.isEmpty(obj.project) && !_.isEmpty(obj.project.refNo)) {
          return obj.project.refNo
        }
        return 'N/A'
      },
      showQuotation (obj) {
        if (!_.isEmpty(obj.quotation) && !_.isEmpty(obj.quotation.refNo)) {
          return obj.quotation.refNo
        }
        return 'N/A'
      },
      showSalesUserPo (salesUserPo) {
        if (!_.isEmpty(salesUserPo)) {
          if (!_.isArray(salesUserPo)) {
            return salesUserPo.user.firstName
          } else {
            let salesName = ''
            for (var key in salesUserPo) {
              let user = salesUserPo[key]
              salesName += user.firstName + ', '
            }
            return salesName.substring(0, salesName.length - 2)
          }
        }
        return 'N/A'
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async getSalesPo () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search || ''
          console.debug(this.pagination)
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/salespo?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'lastUpdateDate'}&dc=${descending || false}&q=${q}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async getQuos () {
        let quoid = this.editedItem.quotation.id
        let companyId = this.editedItem.company.id
        try {
          let response = await this.$http.get(`/api/quo/select?include=${quoid}&companyid=${companyId}`)
          this.quotations = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          console.debug('-- get comppaging-- ' + this.searchCompany)
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)
          console.debug(response.data)
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },

      reset () {
        this.$refs.form1.resetValidation()
        this.resetInline()
        this.date = ''
        this.editedItem = Object.assign({}, this.defaultItem)
      },
      close () {
        this.dialog = false
        this.dialog2 = false
        this.showImageError = false
        this.$refs.form1.resetValidation()
        this.fileUrl = ''
        this.imageDownloadUrl = ''
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.attachment = {}
          this.editedIndex = -1
        }, 300)
      },
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (this.editedItem.salesUserPo) {
        } else {
          this.editedItem.salesUserPo = []
        }
        console.debug(this.editedItem)
        this.getQuos()
        // this.searchCompany = this.editedItem.company.name // auto watch=refresh
        this.companies = [this.editedItem.company]
        console.debug(this.companies)
        this.quotations.unshift(this.editedItem.quotation) // reselected
        this.dialog = dbox
      },
      async openFile (item) {
        if (item.fileName && item.fileName.length > 3) {
          console.debug(item.fileName)
          let extension = item.fileName.split('.')[1]
          if (extension !== 'pdf') { // IMAGE OPEN
            await this.openImage(item)
          } else {
            try {
              let response = await axios({
                url: `/api/pdf/salespo/${item.id}`,
                method: 'GET',
                headers: {
                  'Accept': '*/*'
                },
                responseType: 'blob' // important,
              })
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', item.poNo + '.pdf') // or any other extension
              // document.body.appendChild(link)
              link.click()
            } catch (error) {
              console.log(error)
              this.cancelInline()
            }
          }
        } else {
          this.emptyFileSnack()
        }
      },
      async openImage (item, dbox = true) {
        this.imageDownloadUrl = item.filePath + '/' + item.fileName + '?v=' + this.imgCounter
        this.imgCounter = this.imgCounter + 1
        console.debug(this.imageDownloadUrl)
        // SECURED IMAGE, I
        // let imageData = {}
        // imageData.endpoint = item.filePath + '/' + item.fileName
        // imageData.containerId = 'poImageContainer'
        // try {
        // let response = await this.$store.dispatch('getSecuredImage', imageData)
        // } catch (error) {
        //   console.log(error)
        // }
        this.showImageError = false
        this.dialog2 = dbox
      },
      async deleteItem (rec) {
        this.dialogDelete = false
        let endpoint = `api/salespo/${rec.id}`
        let method = 'delete'
        let s = {}
        try {
          let response = await this.$store.dispatch('updateTableItem', { endpoint, s, method })
          this.DataList.splice(this.DataList.indexOf(rec), 1)
          this.deleteInline()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      async saveFormData () {
        let tableItem = this.editedItem
        let file = this.attachment
        if (!tableItem.company.id) {
          this.companyEmptySnack()
          return
        }
        if (tableItem.salesUserPo) {
          let sup = tableItem.salesUserPo
          if (sup.length > 0) {
            for (var key in sup) {
              let ob = sup[key]
              if (!ob.id) {
                this.cancelInline('Selected User cannot be empty')
                return
              }
            }
          }
        }
        console.debug(file)
        if (this.editedIndex > -1) {
          let endpoint = `api/salespo/${this.editedItem.id}`
          let method = 'post'
          try {
            let response = await this.$store.dispatch('postFormData', { file, tableItem, endpoint })
            Object.assign(this.DataList[this.editedIndex], this.editedItem)
            this.saveInline()
            this.getSalesPo()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        } else {
          let endpoint = `api/salespo`
          let method = 'post'
          try {
            let resp = await this.$store.dispatch('postFormData', { file, tableItem, endpoint })
            this.saveInline()
            this.getSalesPo()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        }
        this.close()
      },
      async save () {
        let tableItem = this.editedItem
        tableItem.customer = this.editedItem.customerSelect
        if (this.editedIndex > -1) {
          let endpoint = `api/salespo/${this.editedItem.id}`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            Object.assign(this.DataList[this.editedIndex], this.editedItem)
            this.saveInline()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        } else {
          let endpoint = `api/salespo`
          let method = 'post'
          try {
            let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            this.saveInline()
            this.getSalesPo()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        }
        this.close()
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (msg) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = msg || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      resetInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      fileFormatSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select jpg/png/pdf file'
      },
      companyEmptySnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please input Company'
      },
      emptyFileSnack () {
        this.snack = true
        this.snackColor = 'warning'
        this.snackText = 'This PO don\'t have a file'
      },
      closeInline () {
        console.debug(this.editedItem.items)
        console.debug('Dialog closed')
      }

    }

  }
</script>
<style scoped>
  #poImageContainer {
    height: auto;
    max-width: 100%;
  }
</style>
